import DetailsModal from '../Modal/DetailsModal'

import { IWisDetailsModalBodyProps } from './types'

export const WisDetailsModalBody = ({
  children,
  isOpen,
  close,
  title = 'Details'
}: React.PropsWithChildren<IWisDetailsModalBodyProps>) => {
  return (
    <DetailsModal
      titleClassName='font-bold'
      title={title}
      open={isOpen}
      close={close}
    >
      <div className='flex flex-col overflow-auto border-y border-gray-300 pt-6 w-120 h-[496px]'>
        {children}
      </div>
    </DetailsModal>
  )
}

export default WisDetailsModalBody
